import styled from 'styled-components';

export const EmptyList = styled.p`
	position: relative;
  margin: 20px auto;
	font-size: 20px;
	color: white;
`